import { AlertCircle } from 'lucide-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { APP_CONFIG } from '@config';
import NotFound from './NotFound';

const Page404: React.FC = () => {
    const { t } = useTranslation('ui');

    useEffect(() => {
        document.title = `${t('errors.page_not_found', 'Página no encontrada')} - ${APP_CONFIG.appName}`;
    }, [t]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <NotFound
                entityType="Página"
                title="Página no encontrada"
                message="La página que estás buscando no existe. Puede que haya sido movida, eliminada o que hayas ingresado una URL incorrecta."
                backButtonText="Volver atrás"
                showHomeButton={true}
                homeButtonText="Ir al inicio"
                homePath="/"
                icon={
                    <div className="w-20 h-20 bg-destructive/10 rounded-full flex items-center justify-center">
                        <AlertCircle className="w-10 h-10 text-destructive" />
                    </div>
                }
                testId="page-404"
            />
        </div>
    );
};

export default Page404; 